import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import HomePage from '@/pages/HomePage';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import GalleryPage from '@/pages/GalleryPage';
import AdminLoginPage from '@/pages/AdminLoginPage';
import AdminDashboard from '@/pages/AdminDashboard';
import StaffDashboard from '@/pages/StaffDashboard';
import BookingSuccessPage from '@/pages/BookingSuccessPage';
import BillingPage from '@/pages/BillingPage';
import UserProfilePage from '@/pages/UserProfilePage';
import CookiePolicyPage from '@/pages/CookiePolicyPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import ImpressumPage from '@/pages/ImpressumPage';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import CookieBanner from '@/components/CookieBanner';
import '@/App.css';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

const AdminRoute = () => {
  const { user } = useAuth();
  if (!user || !user.is_admin) {
    return <Navigate to="/admin/login" replace />;
  }
  return user.role === 'super_admin' ? <AdminDashboard /> : <StaffDashboard />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/booking-success" element={<BookingSuccessPage />} />
            <Route path="/angebote" element={<BillingPage />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <UserProfilePage />
                </ProtectedRoute>
              }
            />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route
              path="/admin/dashboard"
              element={
                <AdminRoute />
              }
            />
          </Routes>
          <Toaster position="top-center" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
